import { TableColumn } from "@maersk-global/mds-components-core/mc-table/types";

const stringDataType: TableColumn['dataType'] = {
    type: 'string',
    formatter: (value) => (value as string) || '',
};

export const RepairCodeListGridColumns: Array<TableColumn> = [
    {
        id: 'repairCode',
        label: 'Repair Code',
        sortDisabled: true,
        width: '8%'
    },
    {
        id: 'description',
        label: 'Description',
        sortDisabled: true,
        width: '40%'
    },
    {
        id: 'repairMode',
        label: 'Mode',
        width: '8%',
        dataType: stringDataType
    },
    {
        id: 'isActiveDisplay',
        label: 'Repair Active',
        width: '15%',
        dataType: stringDataType
    },
    {
        id: 'allowPartsDisplay',
        label: 'Parts Allowed',
        width: '15%',
        dataType: stringDataType
    },
    {
        id: 'multipleEqDisplay',
        label: 'Multiple EQ',
        width: '14%',
        dataType: stringDataType
    }
];
